import type { Booking } from '@/entities/bookings/booking.entity.ts';

export const bookingLocationToCoordinates = (booking: Booking, mode: 'pickup' | 'dropoff') => {
  return booking[`${mode}LocationType`] === 'STATION'
    ? booking[`${mode}Station`]?.location.coordinates
    : booking[`${mode}Location`]?.coordinates;
};
